import { render, staticRenderFns } from "./FileCustomField.vue?vue&type=template&id=87679e3a&"
import script from "./FileCustomField.vue?vue&type=script&lang=ts&"
export * from "./FileCustomField.vue?vue&type=script&lang=ts&"
import style0 from "./FileCustomField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VCol,VFileInput})
